import { Component, OnInit } from '@angular/core';
import { environment } from '@env/environment';
import { Router } from '@angular/router';
import { URL_PATH } from '@app/@core/constants/training.constants';
import { NotificationDTO } from '@app/@core/models/login-models';
import { AuthenticationService } from '@app/login';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'scf-releases',
  templateUrl: './releases.component.html',
  styleUrls: ['./releases.component.scss'],
})
export class ReleasesComponent implements OnInit {
  releases: NotificationDTO[];
  routePdf: any;
  srcUrl: any;
  numberRelease: number = 0;

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.authenticationService.getReleases().subscribe((data: NotificationDTO[]) => {
      if (data.length > 0) {
        this.releases = data;
        localStorage.setItem('releases', JSON.stringify(this.releases));
      } else {
        this.releases = JSON.parse(localStorage.getItem('releases'));
      }
      if (this.releases.length > 0 && this.releases.length >= this.numberRelease + 1) {
        this.pdfOrJasper();
        this.video();
      }
    });
  }

  accept() {
    this.authenticationService
      .postIncreaseCounterNotifications(this.releases[this.numberRelease].id)
      .toPromise()
      .then(
        (data: any) => {
          if (data) {
            if (this.releases.length > 0 && this.releases.length > this.numberRelease + 1) {
              this.numberRelease++;
              this.pdfOrJasper();
              this.video();
            } else {
              this.router.navigate(['/home'], { replaceUrl: false });
            }
          }
        },
        (error) => {
          console.log(error);
        }
      );
  }

  pdfOrJasper() {
    console.log(this.numberRelease);
    console.log(this.releases[this.numberRelease]);
    if (this.releases[this.numberRelease].pdf) {
      this.routePdf = this.sanitizer.bypassSecurityTrustResourceUrl(
        URL_PATH + this.releases[this.numberRelease].filename + '#toolbar=0&view=Fit'
      );
    } else if (this.releases[this.numberRelease].jasper) {
      this.authenticationService
        .postPrintJasperNotification(this.releases[this.numberRelease].id)
        .toPromise()
        .then(
          (data: any) => {
            if (data) {
              let file = new Blob([data], { type: 'application/pdf' });
              let fileURL = URL.createObjectURL(file);
              this.routePdf = this.sanitizer.bypassSecurityTrustResourceUrl(fileURL + '#toolbar=0');
            }
          },
          (error) => {
            console.log(error);
          }
        );
    }
  }

  video() {
    if (this.releases[this.numberRelease].video) {
      this.srcUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        this.releases[this.numberRelease].link + '#toolbar=0'
      );
    }
  }

  // private _base64ToArrayBuffer(base64: any) {
  //   let binary_string = window.atob(base64);
  //   let len = binary_string.length;
  //   let bytes = new Uint8Array(len);
  //   for (var i = 0; i < len; i++) {
  //     bytes[i] = binary_string.charCodeAt(i);
  //   }
  //   this.routePdf = bytes;
  // }

  // private blobToBASE64(blob: any): any {
  //   let reader = new FileReader();
  //   reader.readAsDataURL(blob);
  //   reader.onloadend = () => {
  //     var base64result = reader.result.toString().split(',')[1];
  //     this._base64ToArrayBuffer(base64result);
  //   };
  // }
}
